// Export the main Sidebar component
export { default } from './Sidebar';
